module.exports = __webpack_public_path__ + "img/149.71ac9890.jpg";